import { motion } from "framer-motion";
import { SERVICES } from "@/data";

const EASE = [0.16, 1, 0.3, 1];

export default function Services({ onEnquire }) {
    return (
        <section id="services">
            <div className="wrap">
                <motion.div
                    className="gov-strip"
                    data-testid="gov-defence-strip"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <div className="gov-label">GOVERNMENT &amp; DEFENCE</div>
                    <p className="gov-copy">
                        SoftwareFairGo is an Australia-based firm, cleared for
                        public-sector work: every professional on an
                        engagement holds an Australian Government Baseline
                        security clearance, with NV1-cleared consultants
                        available when the work demands it.
                    </p>
                    <div className="gov-chips">
                        <span>AUSTRALIA-BASED FIRM</span>
                        <span>ALL CONSULTANTS — BASELINE CLEARED</span>
                        <span>NV1-CLEARED CONSULTANTS AVAILABLE</span>
                        <span>REMOTE OR ON-SITE — AU &amp; NZ</span>
                    </div>
                </motion.div>

                <motion.div
                    className="section-head"
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: EASE }}
                >
                    <div>
                        <h2>Services &amp; pricing</h2>
                    </div>
                    <p className="section-desc">
                        Reach us for an estimate — charges are based on each
                        professional's market day rate and the scope of your
                        work.
                    </p>
                </motion.div>

                <div className="service-list">
                    {SERVICES.map((s, i) => (
                        <motion.div
                            className={`service-row service-row-${s.num}`}
                            data-testid={`service-row-${s.num}`}
                            key={s.num}
                            initial={{ opacity: 0, y: 28 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.25 }}
                            transition={{
                                duration: 0.7,
                                ease: EASE,
                                delay: (i % 3) * 0.06,
                            }}
                        >
                            <div>
                                <h3>{s.title}</h3>
                                <p>{s.desc}</p>
                                <ul>
                                    {s.items.map((it) => (
                                        <li key={it}>{it}</li>
                                    ))}
                                </ul>
                            </div>
                            <div className="service-price-col">
                                <div className="service-price">
                                    {s.price}
                                    <span className="unit">{s.unit}</span>
                                </div>
                                <button
                                    className="service-cta"
                                    data-testid={`service-enquire-${s.num}`}
                                    onClick={() => onEnquire(s.selectValue)}
                                >
                                    {s.cta}
                                </button>
                            </div>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className="rate-note"
                    initial={{ opacity: 0, y: 16 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, amount: 0.4 }}
                    transition={{ duration: 0.7, ease: EASE }}
                >
                    <span>
                        Reach us for an estimate — charges based on each
                        professional's market day rate
                    </span>
                    <span data-testid="clearance-note-services">
                        Government ready: all consultants Baseline-cleared ·
                        NV1 available
                    </span>
                    <span>Remote by default · on-site by arrangement</span>
                </motion.div>
            </div>
        </section>
    );
}
